import {
    allowNavigationAway,
    initEventListeners as initNavAwayEventListeners
} from "./navigationAway";

document.addEventListener('alpine:init', () => {
    /**
     * Object to manage data contained within a slider form.
     *
     * @param string cancelEvent name of the event to call when clicking the cancel button on a slider
     */
    Alpine.data('formManager', (orderClean, cancelEvent = 'cancelChanges') => ({
        /**
         * @var string Name of the slider form we are acting on.
         */
        triggerName: '',

        /**
         * @var string The method name for submitting.
         */
        triggerMethod: '',

        /**
         * @var bool Is a message currently being sent via the wire.
         */
        messageSending: false,

        /**
         * @var bool whether a confirmation is allowed when canceling the form
         */
        orderIsClean: orderClean,

         /**
          * @var string cancelEvent name of the event to call when clicking the cancel button on a slider
          */
        cancelEvent: cancelEvent,

        /**
         * Init hooks to track wire status.
         *
         * @return void
         */
        init() {
            initNavAwayEventListeners(this.$root, this.$wire);
            Livewire.hook('commit', ({ commit, succeed }) => {
                this.messageStart();
                succeed(() => {
                    queueMicrotask(() => this.messageSent())
                })
            });
        },

        /**
         * close/Cancel modal form:
         * If the order is clean call the cancelConfirmed function.
         * If the order is dirty popup the cancelConfirmationDialog to make sure the user is aware of the data loss.
         *
         * @param string triggerName Name of the slider form we are acting on.
         *
         * @return void
         */
        async cancelForm(triggerName) {
            var orderIsClean = true;

            this.triggerName = triggerName;

            await this.waitForWire();

            if (this.orderIsClean) {
                this.cancelConfirmed();
            } else {
                this.$store.cancelConfirmationDialog.show();
            }
        },

        /**
         * Save modal form.
         * It is called when the user clicks the save button.
         * Validate form if it is valid call Livewire save method, if it's not valid show confirmation dialog.
         */
        async saveForm(params) {
            const {callMethod, paths, triggerName} = params;
            this.triggerName = triggerName;
            this.triggerMethod = callMethod;
            await this.waitForWire();

            let isValidForm = this.triggerMethod === 'saveNewEntry'
                ?  await this.$wire.validateNewEntry()
                : await this.$wire.validateOrder(paths);

            if (isValidForm) {
                await this.$wire[this.triggerMethod]();
                this.$store.slider.hide(this.triggerName);
                this.$store.invalidConfirmationDialog.hide();
            } else {
                this.$store.invalidConfirmationDialog.show();
            }
        },

        /**
         * Cancel the changes.
         *
         * Hide the slider form and hide the cancelConfirmationDialog if it is open.
         *
         * @return void
         */
        cancelConfirmed() {
            allowNavigationAway();
            this.dispatchCancelEvents();
            this.$store.slider.hide(this.triggerName);
            this.$store.cancelConfirmationDialog.hide();
        },

        /**
         * Confirmed saving invalid data and close slider.
         */
        saveConfirmed() {
            this.$wire[this.triggerMethod]();
            this.$store.invalidConfirmationDialog.hide();
            this.$store.slider.hide(this.triggerName);
        },

        /**
         * Dispatch events for form cancellation .
         */
        dispatchCancelEvents() {
            this.$dispatch(this.cancelEvent);
            this.$dispatch('form-cancel');
        },

        /**
         * Check the status of the wire. Wait until its ready.
         *
         * @return void
         */
        async waitForWire() {
            while (this.messageSending) {
                await new Promise(resolve => setTimeout(resolve, 10));
            }
        },

        /**
         * Called by the livewire hook to flag that a message has started to send.
         *
         * @return void
         */
        messageStart() {
            this.messageSending = true;
        },

        /**
         * Called by the livewire hook when the message is done sending.
         *
         * @return void
         */
        messageSent() {
            this.messageSending = false;
        },
    }));
});
